module.exports = __webpack_public_path__ + "static/media/matches.a9180353.svg";